var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeasons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.87 10.568v5.574c0 .343-.13.667-.351.9a1.121 1.121 0 01-.813.358H6.765c-.299 0-.592-.125-.813-.357a1.31 1.31 0 01-.352-.901v-5.574c0-.344.13-.667.352-.901.221-.233.514-.357.813-.357h7.94c.3 0 .593.124.814.357.222.234.352.557.352.9z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.235 16.142V9.643c0-.739-.279-1.448-.775-1.97a2.581 2.581 0 00-1.872-.817h-.004l-7.937.015",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.284V8.716c0-.985-.372-1.93-1.034-2.628A3.442 3.442 0 0016.471 5h-.007l-7.052.012",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgSeasons;